import { Card, CardHeader,CardContent, Box, Button, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { BuildJobInfo, Log } from "../../../data/interfaces/jobmodels";
import { useContext, useEffect, useState } from "react";
import { InfoTwoTone } from "@mui/icons-material";
import jobService from "../../../data/api/job.service";
import JobLogs from "../../../shared/tablegencomponenents/joblog";
import { CurrentFolderContext } from "../jobsmain";
const BuildStatusHeader = ({ job }: { job: BuildJobInfo | null }) => {
    const {activeTab, setActiveTab,activeJob,setActiveJob } = useContext(CurrentFolderContext);
    //const [currentFolder, setCurrentFolder ] = useContext(CurrentFolderContextType);
    const handleOpenFolder=()=>{
       
        if(job&& job.Id){
            
        setActiveJob(job)
        setActiveTab(2);
        }
    }

    const handleReleaseOrLoad=()=>{
        if(job?.TypeId==1){
            setActiveTab(1);
        }else{
            //Load to DGC
        }
    }


    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">{job?.JobNumber ?? 'Please select a job to see the data.'}</Typography>
            {job == undefined ? '' :<Box component='div' sx={{display:'inline-flex'}}>
                <Box><Button sx={{mr:1}} variant="contained" onClick={handleOpenFolder}>Open</Button>
                {job.TypeId==1?<Button sx={{mr:1}} variant="outlined" onClick={handleReleaseOrLoad}>{'Release'}</Button>:''}</Box>
                </Box> }
        </Box>
    )
}
export default function BuildJob({job,needRefresh}:{job:BuildJobInfo|null,needRefresh:boolean}){
    const [logs,setLogs]=useState<Log[]>([]);
    useEffect(()=>{
        if(job){
            if(needRefresh&&job.Progress<100){
                jobService.getJobLogsBg(job?.Id??0).then((response)=>{
                    setLogs(response.data);
                });
            }
            else{
        jobService.getJobLogs(job?.Id??0).then((response)=>{
            setLogs(response.data);
        });
    }
    }
    },[job])
    return(
        <Card>
            <CardHeader title={<BuildStatusHeader job={job}/>}/>
            <CardContent>
               <JobLogs logs={logs}/>
            </CardContent>
        </Card>
    )
}